let relatedArticleSwiper = document.querySelector("[swiper='related-articles']");

if (relatedArticleSwiper) {

  let swiperElement = relatedArticleSwiper.querySelector(".swiper")

  const articleSwiperNext = relatedArticleSwiper.querySelector(".swiper_button.is--next")
  const articleSwiperPrev = relatedArticleSwiper.querySelector(".swiper_button.is--prev")

  var swiper = new Swiper(swiperElement, {
    speed: 600,
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: false,
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    navigation: {
      nextEl: articleSwiperNext,
      prevEl: articleSwiperPrev,
      disabledClass: 'hide', // Class to add when button is disabled

    },
    breakpoints: {
      480: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1, },
      768: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1, },
      992: {
        slidesPerView: 3,
        spaceBetween: 12,
        slidesPerGroup: 1
      },
    }
  });

}
